import AbstractFilterDefinition from './AbstractFilterDefinition.js'

export default class SelectFilterDefinition extends AbstractFilterDefinition
{
    constructor(name, label, options, multiple = false) {
        super(name, label);
        this.options = options;
        this.multiple = multiple;
    }

    get component() {
        return 'select-filter';
    }

    dataAdapter(data) {
        return data.choice;
    }

    get configuration() {
        let tmpOptions = typeof this.options == 'function' ? this.options() : this.options;
        let options = {};

        tmpOptions.forEach(function(option) {
            options[option.value] = option;
        });

        return {
            'choice': {
                'type': 'select',
                'name':'choice',
                'options': options,
                'multiple': this.multiple,
            }
        };
    }
}